export default __webpack_public_path__ + "static/media/M36.2ed6fed6.svg";